<div *ngIf="layoutModel && layoutModel.isVisible">
  <wm-data-entity-input-list
    [form]="form"
    [entities]="layoutModel.groupEntities"
    [applicationId]="applicationId"
    [activity]="activity"
    [isPreview]="isReadOnly"
    #dataEntityInputList
  >
  </wm-data-entity-input-list>
</div>
